import { render, staticRenderFns } from "./VehicleUsageCreateView.vue?vue&type=template&id=538f1cae"
import script from "./VehicleUsageCreateView.vue?vue&type=script&lang=js"
export * from "./VehicleUsageCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports